import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { SAASBRANDNAME } from 'src/assets/data/enum/saasBrandName.enum';
import { ThemeConfig } from 'src/assets/data/enum/themeConfig';
import { environment } from '../../../environments/environment';
import { Customer } from '../_models/customer';

@Injectable()
export class CustomerService {
  private apiBaseUrl = environment.apiBaseUrl;
  list = [];

  constructor(private http: HttpClient) {}

  getCustomers(): Observable<Customer[]> {
    const xSaas = ThemeConfig.brand || SAASBRANDNAME.XFARM;

    // Set the SaaS brand to receive the correct products from the backend
    const headers = new HttpHeaders({ 'x-saas': xSaas.toLocaleLowerCase() });

    return this.http
      .get<Customer[]>(this.apiBaseUrl + 'api/private/v2/customers', { headers })
      .pipe(
        map((response) => {
          this.list = response;
          return response;
        })
      );
  }

  getCustomer(id: number): Observable<Customer> {
    return this.http
      .get<any>(this.apiBaseUrl + 'api/private/v2/customers/' + id)
      .pipe(map((response) => response));
  }

  saveCustomer(customerItem): Observable<Customer> {
    const customer = { ...customerItem };
    delete customer.lastUpdated;
    delete customer.dateCreated;

    const companySelected = JSON.parse(localStorage.getItem('companySelected'));
    customer.companyId = companySelected ? companySelected.id : null;

    if (customer.user != null && customer.user.id != null) {
      customer.user = { id: customer.user.id };
    }
    if (customer.id) {
      return this.http
        .put<Customer>(this.apiBaseUrl + 'api/private/v2/customers/' + customer.id, customer)
        .pipe(map((response) => response));
    } else {
      return this.http
        .post<Customer>(this.apiBaseUrl + 'api/private/v2/customers/', customer)
        .pipe(map((response) => response));
    }
  }

  deleteCustomer(id: number): Observable<Customer> {
    return this.http.delete(this.apiBaseUrl + 'api/private/v1/customers/' + id).pipe(
      map(() => {
        return { id } as Customer;
      })
    );
  }

  getLocalCustomerById = (id: number): Customer => {
    return this.list.find((f) => f.id === id);
  };
}
